import { BigValue } from '../../utils/types'

const numTradingDaysPerYear = 365.242199
const numMilliSecondsPerDay = 86400000

/**
 * APR formula : (dailyFees*365)/tvl*100
 * APY formula : ((1 + fees / tvl)^365-1)*100
 * @param tvl
 * @param dailyFees
 */
export function calculateApr(tvl: number, dailyFees: number) {
  return (dailyFees * numTradingDaysPerYear) / tvl
}

export function calculateAprFromPoolTokenPrices(poolTokenPriceBefore: number, poolTokenPriceAfter: number, timeWindowInSec: number) {
  return (poolTokenPriceAfter / poolTokenPriceBefore - 1) * numTradingDaysPerYear / (timeWindowInSec / numMilliSecondsPerDay)
}
